export const cacheAnimation = {};
export async function loadAnimation(url) {
    if (cacheAnimation[url]) return cacheAnimation[url];
    const response = await fetch(url);
    const json = await response.json();
    cacheAnimation[url] = json;
    return json;
}